import type { HighlightMergeFieldKey } from "../types/templateMerge";
import type { ContractReviewForm } from "../types/template";
import { formatDateForDocumentMergeLong } from "../utils/displayDate";

/**
 * Resolves a merge key to the string written into the document at the matching yellow highlight.
 */
export const getFormValueForMergeField = (
  field: HighlightMergeFieldKey,
  form: ContractReviewForm
): string => {
  switch (field) {
    case "effectiveDate":
      return formatDateForDocumentMergeLong(form.effectiveDate);
    case "contactName":
      return form.contactName.trim();
    case "legalEntityName":
      return form.legalEntityName.trim();
    case "representativeName":
      return form.representativeName.trim();
    case "representativeTitle":
      return form.representativeTitle.trim();
    case "representativeCompanyName":
      return form.representativeCompanyName.trim();
    case "representativeAddress":
      return form.representativeAddress.trim();
    case "representativeStreetAddress":
      return form.representativeStreetAddress.trim();
    case "representativeCityStateZip":
      return form.representativeCityStateZip.trim();
    case "representativePhone":
      return form.representativePhone.trim();
    case "representativeEmail":
      return form.representativeEmail.trim();
    case "clientAddress":
      return form.addressMerged.trim();
    case "companyStreetAddress":
      return form.companyStreetAddress.trim();
    case "companyCityStateZip":
      return form.companyCityStateZip.trim();
    case "phone":
      return form.phone.trim();
    case "email":
      return form.email.trim();
    case "msaEffectiveDate":
      return formatDateForDocumentMergeLong(form.effectiveDate);
    case "planGroupName":
      return form.planGroupName.trim();
    case "contractName":
      return form.contractName.trim();
    case "contactTitle":
      return form.contactTitle.trim();
    default: {
      const _exhaustive: never = field;
      return _exhaustive;
    }
  }
};
